export default "__VITE_ASSET__BSXjwmYi__"